import { ENV } from '@/env';

const APP_SUBDOMAINS = ['chauffeur'] as const;

export const getEffectiveBaseDomain = (hostname: string = window.location.hostname): string => {
  if (ENV.DEPLOY_ENV === 'dev' || ENV.DEPLOY_ENV === 'staging' || ENV.DEPLOY_ENV === 'local') {
    return ENV.BASE_DOMAIN;
  }

  const canonical = ENV.BASE_DOMAIN;

  if (hostname === canonical || hostname.endsWith(`.${canonical}`)) {
    return canonical;
  }

  const [first, ...rest] = hostname.split('.');

  if (APP_SUBDOMAINS.includes(first as (typeof APP_SUBDOMAINS)[number]) && rest.length >= 2) {
    return rest.join('.');
  }

  return canonical;
};

export const MAIN_HOST = getEffectiveBaseDomain();

const getSiteDomain = (): string => {
  switch (ENV.DEPLOY_ENV) {
    case 'dev':
      return 'https://site.dev.wheely-dev.com';
    case 'local':
    case 'staging':
      return 'https://site.stg.wheely-dev.com';
    default:
      return `https://${MAIN_HOST}`;
  }
};

export const siteDomain = getSiteDomain();
